import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";

const Kat: IModel = {
  title: "Katovi",
  apiPath: "operations/projekti/{projekt_id}/kn/{lokacija_id}",
  forms : {
    "default": {
      fields: [ "kn_id", "obveznik","osoba", "adresa_objekta", "status", "vrsta_prostora", "p_a", "p_b", "lokacija_id", "projekt_id"]
    }
  },
  listViews: {
    "default": {
        fields: [ "kn_id", "obveznik", "osoba", "adresa_objekta", "status", "vrsta_prostora", "p_a", "p_b"]
    }
   
  },
  fields: [
    {
      title: "KN ID",
      source: "kn_id",
      ttoken: "common.id",
      type: "numeric",
      validation: {
        required: true
      },
      readonly: true
    },
    {
      title: "Obveznik",
      source: "obveznik",
      ttoken: "objekti.obveznik",
      type: "text",
      readonly: true,
    },
    {
      title: "Osoba",
      source: "osoba",
      ttoken: "objekti.osoba",
      type: "text",
      validation: {
        required: true,
        maxLength: 20
      },
      readonly: true,
    },
    {
      title: "Adresa objekta",
      source: "adresa_objekta",
      ttoken: "objekti.adresa_objekta",
      type: "text",
      readonly: true,
    },
    {
      title: "Status",
      source: "status",
      ttoken: "lokacije.status",
      type: "numeric",
      readonly: true
    },
    {
      title: "Vrsta prostora",
      source: "vrsta_prostora",
      ttoken: "objekti.vrsta_prostora",
      type: "numeric",
      readonly: true
    },
    {
      title: "P_A",
      source: "p_a",
      ttoken: "objekti.p_a",
      type: "numeric",
      readonly: true
    },
    {
      title: "P_B",
      source: "p_b",
      ttoken: "objekti.p_b",
      type: "numeric",
      readonly: true
    },
    {
      title: "Lokacija ID",
      source: "lokacija_id",
      ttoken: "objekti.lokacija_id",
      type: "numeric"
    },
    {
      title: "Projekt ID",
      source: "projekt_id",
      ttoken: "objekti.projekt_id",
      type: "numeric"
    }
  ]
}

export default Kat;
